<template>
  <section class="main-con">
    <div class="con-tit">{{ $t('terms.contract') }}</div>
    <div class="con-block con-about">
      <div class="about-main" v-html="$t('terms.contractMain')"></div>
      <ul class="notice-list">
        <li>
          <p class="list-tit">ข้อ 1. ความถูกต้องและขอบเขตของการยินยอม</p>
          <p class="list-des">
            ผู้บริโภคเข้าใจดีว่าเมื่อผู้บริโภคลงทะเบียนบัญชีแพลตฟอร์ม Komoe Game
            เรียบร้อยแล้วหมายความว่าผู้บริโภคได้อ่านและทำความเข้าใจเงื่อนไขทั้งหมดของสัญญานี้เป็นเวลานานกว่าสามวัน
            และยินยอมปฏิบัติตามระเบียบการจัดการเกมและกฎที่เกี่ยวข้องกับสัญญานี้และบริการเกมนี้
          </p>
          <p class="list-des">
            สำหรับแอปพลิเคชันบริการเกมหากผู้บริโภคเป็นบุคคลที่ยังไม่บรรลุนิติภาวะ
            (เช่นผู้เยาว์อายุต่ำกว่าเจ็ดขวบ) ตัวแทนทางกฎหมายของเขา /
            ควรแทนที่โดยตัวแทนทางกฎหมายหากเป็นบุคคลที่มีความสามารถ จำกัด
            (อายุเจ็ดปี แต่อายุต่ำกว่า 20 ปี)
            ควรได้รับความยินยอมจากตัวแทนทางกฎหมาย
          </p>
          <p class="list-des">
            เพื่อส่งเสริมพัฒนาการทางร่างกายและจิตใจของเด็กและวัยรุ่นและปกป้องสิทธิและผลประโยชน์ที่เกี่ยวข้องผู้บริโภคเข้าใจว่าบริการนี้อยู่ในระดับที่เหมาะสมภายใต้มาตรฐานการจำแนกประเภทของ
            "มาตรการการจัดการการจัดประเภทซอฟต์แวร์เกม"
            สำหรับระดับที่เฉพาะเจาะจงโปรดดูรายละเอียดซอฟต์แวร์เกมดาวน์โหลดหน้าเริ่มต้นหรือฉลากข้างลิงก์ของบริการนี้
            เมื่อผู้บริโภคได้ลงทะเบียนบัญชีแพลตฟอร์ม Komoe Game
            และลงชื่อเข้าใช้บัญชีแล้วจะถือว่าผู้บริโภคมีคุณสมบัติตามข้อกำหนดด้านอายุของกฎหมายและข้อบังคับที่เกี่ยวข้องสำหรับการใช้บริการระดับนี้
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 2. ขอบเขตของสัญญา</p>
          <p class="list-des">
            ผู้ประกอบธุรกิจให้บริการนี้แก่ผู้บริโภคและสิทธิและหน้าที่ของทั้งผู้บริโภคและผู้ประกอบธุรกิจเกี่ยวกับบริการนี้เป็นไปตามเงื่อนไขของสัญญานี้
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 3. เนื้อหาของสัญญา</p>
          <p class="list-des">
            ต่อไปนี้ถือเป็นส่วนหนึ่งของสัญญานี้ซึ่งมีผลเช่นเดียวกับเงื่อนไขของสัญญานี้：
          </p>
          <ul>
            <li>
              1.
              เนื้อหาโฆษณาหรือประชาสัมพันธ์ของผู้ประกอบธุรกิจเกี่ยวกับบริการเกมนี้
            </li>
            <li>
              2.
              ตารางอัตราและกฎการจัดการเกมและข้อบังคับของเกมระบบการเรียกเก็บเงิน
            </li>
          </ul>
          <p></p>
          <p class="list-des">
            หากมีข้อสงสัยเกี่ยวกับเนื้อหาของสัญญาในวรรคก่อนหน้านี้ให้อธิบายเพื่อประโยชน์ของผู้บริโภค
          </p>
        </li>
        <li>
          <p class="list-tit">บทความและคำนิยามของเนื้อหา</p>
          <p class="list-des">เงื่อนไขของสัญญานี้กำหนดไว้ดังนี้：</p>
          <ul>
            <li>
              1. บริการเกม:
              หมายถึงซอฟต์แวร์ที่ช่วยให้ผู้บริโภคสามารถเชื่อมต่อกับผู้คนจำนวนมากที่ไม่ได้ระบุรายชื่อเพื่อเล่นเกมในเวลาเดียวกันผ่านเซิร์ฟเวอร์เครือข่ายที่ตั้งขึ้นโดยผู้ดำเนินธุรกิจผ่านการเชื่อมต่ออินเทอร์เน็ต
            </li>
            <li>
              2. เว็บไซต์เกม:
              หมายถึงเว็บไซต์ที่ผู้ประกอบธุรกิจจัดตั้งขึ้นเพื่อให้บริการเกมนี้
            </li>
            <li>
              3. กฎการจัดการเกม:
              หมายถึงกฎที่เกี่ยวข้องที่กำหนดขึ้นโดยผู้ประกอบธุรกิจโดยเฉพาะสำหรับข้อบังคับวิธีการเล่นเกมจรรยาบรรณสำหรับสมาชิกและกฎอื่น
              ๆ ที่เกี่ยวข้อง
            </li>
            <li>
              4. ประวัติเกม:
              หมายถึงบันทึกขั้นตอนการใช้บริการเกมของผู้บริโภคโดยระบบคอมพิวเตอร์นับจากเวลาที่ผู้บริโภคล็อกอินเข้าสู่เกม
            </li>
            <li>
              5. จำนวนเงินที่จัดเก็บ:
              หมายถึงจำนวนเงินหรือยอดคงเหลือที่ผู้บริโภคจ่ายให้กับผู้ประกอบธุรกิจล่วงหน้า
            </li>
            <li>
              6. โปรแกรมปลั๊กอิน:
              หมายถึงโปรแกรมที่ไม่ได้จัดทำโดยผู้ประกอบธุรกิจเพื่อจุดประสงค์ในการมีอิทธิพลหรือเปลี่ยนแปลงการดำเนินงานการดำเนินงานและการดำเนินการให้บริการเกมของผู้ประกอบธุรกิจ
            </li>
            <li>
              7. 7. ไอเทมเสมือนจริง:
              อ้างถึงไอเทมที่ผู้บริโภคได้มาผ่านโปรแกรมเกมซึ่งรวมถึง แต่ไม่ จำกัด
              เพียงสกุลเงินเสมือนที่ซื้อโดยผู้บริโภคที่มีจำนวนเงินเก็บไว้
              ผู้ประกอบการธุรกิจจัดหาให้ฟรีหรือผู้บริโภคได้มาจากกิจกรรมเกมหรือสิ่งของที่คล้ายคลึงกัน
              ของเกม
            </li>
            <li>
              8. แพ็คเกจเกม:
              หมายถึงซอฟต์แวร์ที่มีโปรแกรมหลักและโปรแกรมย่อยและสามารถเรียกใช้ฟังก์ชันทั้งหมดของบริการเกมได้อย่างสมบูรณ์
            </li>
            <li>
              9. ดาวน์โหลดซอฟต์แวร์ที่เกี่ยวข้อง:
              หมายถึงการดาวน์โหลดแพ็คเกจเกมจากอินเทอร์เน็ต
            </li>
            <li>
              10. ต้นทุนที่จำเป็น:
              หมายถึงต้นทุนที่ผู้ประกอบธุรกิจจ่ายเพื่อทำสัญญานี้หรือต้นทุนที่จ่ายให้กับบุคคลที่สาม
            </li>
          </ul>
          <p></p>
        </li>
        <li>
          <p class="list-tit">ข้อ 5:จำนวนเงินที่เก็บไว้ของคะแนนเกม</p>
          <p class="list-des">
            เพื่อให้ผู้บริโภคได้เข้าใจแก่นแท้และความสนุกของเกมนี้และในการซื้อไอเทมเสมือนจริงหลังจากเข้าใจความต้องการของผู้บริโภคแล้วผู้บริโภคควรตรวจสอบเนื้อหาของเกมอย่างครบถ้วนก่อนที่จะสามารถจัดเก็บการถือครองภายในเจ็ดวันหลังจากเริ่มต้นบัญชีเกม
            แต่ไม่ จำกัด เพียงการซื้อสิ่งของเสมือนไอเทมหรืออุปกรณ์ตกแต่ง ฯลฯ
          </p>
          <p class="list-des">
            ผู้บริโภคที่ซื้อคะแนนเกมการ์ดรายเดือนรหัสเปิดใช้งานหรือแพ็กเกจผลิตภัณฑ์ที่เกี่ยวข้องของผู้ประกอบธุรกิจหลังจากเปิดและใช้การ์ดหมายความว่าพวกเขาได้ยืนยันการใช้บริการต่างๆที่ผู้ประกอบการธุรกิจจัดหาให้และจุดบริการมี
            ถูกฝากไว้ในบัญชีเกมผู้บริโภคจะไม่สามารถโอนไปยังบุคคลที่สามได้
          </p>
        </li>
        <li>
          <p class="list-tit">มาตรา 6 ขอบเขตการบริการ</p>
          <p class="list-des">
            ผู้บริโภคใช้บริการที่ให้ไว้ในสัญญานี้เพื่อดาวน์โหลดและเข้าถึงแอปพลิเคชันเกมผ่านคอมพิวเตอร์ส่วนบุคคลอุปกรณ์พกพาหรือวิธีการอื่น
            ๆ และล็อคอินเพื่อเล่นเกมผ่านการเชื่อมต่ออินเทอร์เน็ต
            ไม่รวมถึงผู้บริโภคที่สมัครใช้บริการอินเทอร์เน็ตจากผู้ให้บริการการเข้าถึงอินเทอร์เน็ตและจัดหาอุปกรณ์ฮาร์ดแวร์ต่างๆที่จำเป็นสำหรับการเข้าถึงอินเทอร์เน็ต
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 7 การล็อคอินเกม</p>
          <p class="list-des">
            ผู้บริโภคที่สมัครใช้บริการเกมนี้ควรล็อคอินข้อมูลส่วนบุคคลที่ตรงกับเอกสารระบุตัวตนบนเว็บไซต์เกมหรือตามความต้องการของเกม
            หากข้อมูลส่วนบุคคลที่ลงทะเบียนโดยผู้บริโภคไม่ถูกต้องหรือมีการเปลี่ยนแปลงจะได้รับการแก้ไขทันที
          </p>
          <p class="list-des">
            หากผู้บริโภคไม่ให้ข้อมูลส่วนบุคคลที่ถูกต้องหรือข้อมูลต้นฉบับที่ให้มาไม่เป็นความจริงและไม่ได้รับการแก้ไขผู้ประกอบธุรกิจอาจระงับบริการ
            (รวมถึง แต่ไม่ จำกัด เพียงการระงับการใช้เกมของผู้บริโภค)
            ก่อนที่ผู้บริโภคจะให้
            ข้อมูลจริงหรือปรับปรุงข้อมูลบริการและให้บริการสอบถามประวัติเกม)
            อย่างไรก็ตามหากผู้บริโภคสามารถพิสูจน์ได้ว่าเขาเป็นคู่สัญญาด้วยวิธีการอื่นที่ไม่ใช่ข้อมูลส่วนบุคคลจะไม่มีผลบังคับใช้
          </p>
          <p class="list-des">
            ผู้บริโภคอาจจะส่งอีเมลหรือเขียนแจ้งให้ผู้ประกอบการที่จะยกเลิกข้อตกลงนี้ภายในเจ็ดวันหลังจากเริ่มเกมและผู้บริโภคจะไม่ต้องอธิบายเหตุผลและค่าใช้จ่ายใดๆ
            หลังจากการยกเลิกสัญญาผู้บริโภคอาจขอเงินคืนจากผู้ประกอบการของบริษัทสำหรับจุดที่ไม่ได้ใช้ซื้อ
          </p>
          <p class="list-des">
            ถ้าบุคคลที่มีความสามารถในการจำกัดการกระทำโดยไม่ได้รับความยินยอมของตัวแทนทางกฎหมายหรือผู้ที่ไม่มีความสามารถในการปฏิบัติที่ล้มเหลวในการเรียกร้องคืนเงินค่าธรรมเนียมที่เกิดจากการจ่ายค่าธรรมเนียมในนามของตัวแทนทางกฎหมายตัวแทนทางกฎหมายจะเตรียมเอกสารรับรอง
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 8. มาตรฐานการเรียกเก็บเงิน</p>
          <p clss="list-des">วิธีการคำนวณค่าธรรมเนียมสำหรับบริการเกมนี้คือ：</p>
          <p class="list-des">
            ระบบฟรี แต่รายการชำระเงินบางรายการยังสามารถซื้อได้
          </p>
          <p class="list-des">
            เมื่อมีการปรับอัตราค่าธรรมเนียมผู้ประกอบธุรกิจควรประกาศบนเว็บไซต์เกม
            เกมที่อยู่ระหว่างดำเนินการหน้าล็อกอินเกมหรือหน้าการซื้อ 30
            วันก่อนวันที่มีผลบังคับใช้ของการปรับตามกำหนดการหากผู้บริโภคเข้าสู่ระบบ
            ข้อมูลการสื่อสารเมื่อลงทะเบียนบัญชีและผู้บริโภคข้อมูลการสื่อสารที่ลงทะเบียนจะแจ้งให้ผู้บริโภคทราบ
          </p>
          <p class="list-des">
            หากมีการปรับอัตราจะต้องคำนวณและรวบรวมอัตราใหม่ตั้งแต่วันที่มีผลของการปรับปรุงหากอัตราใหม่สูงกว่าอัตราเดิมผู้บริโภคได้ซื้อและใช้หรือเข้าสู่ระบบเว็บไซต์เกมก่อนวันที่มีผลบังคับใช้
            อัตราใหม่คะแนนมูลค่าที่เก็บไว้หรือค่าธรรมเนียมเกมควรจะถูกเรียกเก็บในอัตรา
          </p>
          <p class="list-des">
            ผู้บริโภคทราบและยอมรับว่าวิธีการคำนวณการบริโภคไอเทมเสมือน (สกุลเงิน)
            ในบริการเกมนี้คือการให้ความสำคัญกับไอเท็มเสมือน (สกุลเงิน)
            ที่ได้รับจากการหักมูลค่าที่เก็บไว้และสามารถหักรายการเสมือน
            (สกุลเงิน) ได้ฟรีก่อน รายการเสมือน (สกุลเงิน) จะถูกหักออก (สกุลเงิน)
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 9. ข้อมูลที่จะรวมอยู่ในเกมนี้</p>
          <p class="list-des">
            ผู้ประกอบการธุรกิจจะต้องระบุรายการต่อไปนี้ในเว็บไซต์เกมและบรรจุภัณฑ์ของชุดเกม：
          </p>
          <ul>
            <li>
              1.
              ตามข้อบังคับเกี่ยวกับการจัดการการจัดประเภทซอฟต์แวร์เกมให้ทำเครื่องหมายระดับการจัดประเภทเกมและกลุ่มอายุที่ต้องห้ามหรือเหมาะสม
            </li>
            <li>2. ข้อกำหนดฮาร์ดแวร์และซอฟต์แวร์ขั้นต่ำสำหรับเกมนี้</li>
            <li>
              3.
              เกมนี้มีอุปกรณ์ล็อคเพื่อความปลอดภัยในการสื่อสารและผู้บริโภคสามารถกำหนดหมายเลขการใช้งานได้ด้วยตัวเอง
            </li>
            <li>
              4.ข้อมูลเกี่ยวกับสินค้าที่ได้รับรางวัลรางวัลและรางวัลจะถูกบันทึกไว้เป็นข้อมูลเกี่ยวกับสินค้าที่ได้รับรางวัลและเคล็ดลับสำหรับผู้บริโภคที่จะซื้อหรือเข้าร่วมกิจกรรม
            </li>
          </ul>
          <p></p>
        </li>
        <li>
          <p class="list-tit">ข้อ 10. การใช้หมายเลขบัญชีและรหัสผ่าน</p>
          <p class="list-des">
            หลังจากผู้บริโภคเสร็จสิ้นขั้นตอนการลงทะเบียน
            ผู้ประกอบธุรกิจจะให้ชุดหมายเลขบัญชีและรหัสผ่านชุดหมายเลขบัญชีและรหัสผ่านมีไว้สำหรับผู้บริโภคเท่านั้น
            ห้ามมิให้ผู้บริโภคโอนหรือให้ยืมหมายเลขบัญชีและรหัสผ่านไปยังบุคคลภายนอกเพื่อใช้งานหากมีข้อพิพาทเกิดขึ้นผู้บริโภคจะต้องรับผิดชอบ
          </p>
          <p class="list-des">
            รหัสผ่านในย่อหน้าก่อนหน้านี้อาจเปลี่ยนแปลงได้ตามกลไกการแก้ไขที่ผู้ประกอบธุรกิจกำหนด
            ผู้ประกอบการธุรกิจ (รวมถึงเจ้าหน้าที่บริการลูกค้าและผู้ดูแลเกม)
            จะไม่ถามรหัสผ่านจากผู้บริโภค
            ผู้บริโภคมีหน้าที่รับผิดชอบอย่างเต็มที่ในการดูแลบัญชีเกมและรหัสผ่านที่พวกเขามีอยู่หากผู้อื่นใช้บัญชีและรหัสผ่านอย่างผิดกฎหมายเนื่องจากการควบคุมดูแลที่ไม่เหมาะสมนี่เป็นสถานการณ์ที่เกิดขึ้นกับผู้บริโภคและผู้บริโภคต้องรับผิดชอบด้วย
          </p>
        </li>
        <li>
          <p class="list-tit">
            มาตรา 11:
            การแจ้งเตือนและการจัดการการใช้งานบัญชีและรหัสผ่านอย่างผิดกฎหมาย
          </p>
          <p class="list-des">
            หากฝ่ายใดฝ่ายหนึ่งพบว่าบุคคลที่สามใช้บัญชีของผู้บริโภคอย่างผิดกฎหมายหรือได้รับความเสียหายในการใช้งานบัญชีจะต้องแจ้งให้อีกฝ่ายทราบทันที
            หลังจากตรวจสอบและยืนยันสถานการณ์ที่กล่าวมาแล้วผู้ประกอบธุรกิจอาจระงับการใช้บัญชีหรือรหัสผ่านของกลุ่มแจ้งให้ผู้บริโภคทราบทางอีเมลหรือวิธีการอื่นเพื่อเปลี่ยนรหัสผ่านใหม่และจำกัดสิทธิ์ของบุคคลที่สามในการใช้บริการเกมทันที
          </p>
          <p class="list-des">
            ผู้ประกอบธุรกิจจะต้องแจ้งบุคคลที่สามที่กล่าวถึงในย่อหน้าก่อนหน้านี้ทันทีเพื่อให้คำอธิบายผ่านทางประกาศทางเว็บไซต์ประกาศเกี่ยวกับเกมหรืออีเมลหรือวิธีการอื่น
            ๆ ตั้งแต่เวลาที่สิทธิ์ในการใช้บริการเกมถูก จำกัด ชั่วคราว
            หากบุคคลที่สามไม่ให้คำอธิบายภายในเจ็ดวันหลังจากได้รับการแจ้งเตือนผู้ประกอบธุรกิจจะต้องตอบกลับโดยตรงไปยังผู้บริโภค
            เกี่ยวกับบันทึกที่ถ่ายโอนอย่างไม่ถูกต้องหากไม่สามารถตอบกลับได้อาจใช้วิธีการชดเชยอื่น
            ๆ ที่เทียบเท่าซึ่งตกลงกันโดยทั้งสองฝ่าย และหลังจากการตอบกลับข้อ
            จำกัด ของบุคคลที่สามจะถูกยกเลิก
            อย่างไรก็ตามหากผู้ประกอบธุรกิจจัดหาอุปกรณ์รักษาความปลอดภัยฟรี
            (เช่นการ์ดป้องกันการโจรกรรมล็อคโทรศัพท์ ฯลฯ )
            และผู้บริโภคไม่ได้ใช้หรือมีอุปกรณ์อื่น ๆ
            เหตุผลที่เป็นของผู้บริโภคผู้ประกอบธุรกิจไม่อาจรับผิดชอบในการกู้คืนหรือชดเชย
          </p>
          <p class="list-des">
            เมื่อบุคคลที่สามของวรรคหนึ่งไม่เห็นด้วยกับการจัดการวรรคก่อนหน้าของผู้ประกอบธุรกิจผู้บริโภคอาจปฏิบัติตามขั้นตอนในการรายงานคดีและจัดการผ่านช่องทางการพิจารณาคดี
          </p>
          <p class="list-des">
            เมื่อผู้ประกอบธุรกิจ
            จำกัดสิทธิ์ในการใช้งานของผู้บริโภคหรือบุคคลภายนอกตามวรรคหนึ่งผู้ประกอบธุรกิจจะไม่เรียกเก็บเงินจากผู้บริโภคหรือบุคคลที่สามในช่วงเวลาที่
            จำกัด การใช้งาน
          </p>
          <p class="list-des">
            ผู้บริโภคจะต้องรับผิดชอบทางกฎหมายทั้งหมดในกรณีที่รายงานอันเป็นเท็จก่อให้เกิดความเสียหายต่อสิทธิของผู้ประกอบธุรกิจหรือบุคคลที่สาม
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 12. บันทึกและสอบถามประวัติเกม</p>
          <p class="list-des">
            ผู้ประกอบธุรกิจควรเก็บบันทึกประวัติเกมส่วนตัวของผู้บริโภคและระยะเวลาเก็บรักษาคือ
            30 วันสำหรับผู้บริโภคในการสอบถาม
            ผู้ประกอบธุรกิจที่ค้างชำระไม่สามารถรับคำขอสอบถามได้
          </p>
          <p class="list-des">
            ผู้บริโภคสามารถสมัครเป็นลายลักษณ์อักษรออนไลน์หรือด้วยตนเองที่ศูนย์บริการของผู้ประกอบธุรกิจเพื่ออ่านประวัติเกมส่วนตัวของผู้บริโภคและต้องส่งข้อมูลส่วนบุคคลที่ตรงกับเอกสารระบุตัวตนเพื่อการตรวจสอบผู้ประกอบธุรกิจอาจเรียกเก็บเงินสองร้อยหยวนไต้หวัน
            ใช้เป็นค่าธรรมเนียมการสอบถามซึ่งเป็นภาระของผู้บริโภค
          </p>
          <p class="list-des">
            ผู้ประกอบธุรกิจจะต้องให้ประวัติเกมส่วนตัวของผู้บริโภคที่ระบุไว้ในข้อ
            1
            เมื่อได้รับการสอบถามจากผู้บริโภคและให้ข้อมูลในสื่อบันทึกข้อมูลเป็นลายลักษณ์อักษรหรืออีเมลภายใน7วัน
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 13. ข้อมูลส่วนบุคคล</p>
          <p class="list-des">
            เกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลจะต้องได้รับการจัดการตามกฎหมายและข้อบังคับที่เกี่ยวข้อง
          </p>
          <p class="list-des">
            เว้นแต่จะเป็นไปตามกฎหมายหรือข้อกำหนดของหน่วยงานที่เกี่ยวข้องโดยไม่ได้รับความยินยอมจากผู้บริโภคผู้ประกอบธุรกิจจะต้องไม่ขายแลกเปลี่ยนให้เช่าหรือเปิดเผยชื่อที่อยู่อีเมลและข้อมูลส่วนบุคคลอื่น
            ๆ ที่ได้รับการคุ้มครองตามกฎหมายของผู้บริโภคโดยพลการ
          </p>
          <p class="list-des">
            ผู้ประกอบธุรกิจอาจใช้ข้อมูลส่วนบุคคลของผู้บริโภคเพื่อให้บริการอื่น ๆ
            แก่ผู้บริโภคภายในขอบเขตของการปฏิบัติตามวัตถุประสงค์ของสัญญา
          </p>
          <p class="list-des">
            ผู้บริโภคยอมรับว่าผู้ประกอบธุรกิจอาจรวบรวมสถิติการเป็นสมาชิกโดยอาศัยข้อมูลส่วนบุคคลของผู้บริโภค
            หากข้อมูลทางสถิติไม่เกี่ยวข้องกับการเปิดเผยตัวตนส่วนบุคคลของผู้บริโภคผู้บริโภคยินยอมและอนุญาตให้ผู้ประกอบธุรกิจใช้ข้อมูลดังกล่าวเพื่อการใช้งานที่ชอบด้วยกฎหมายและเปิดเผย
          </p>
          <p class="list-des">
            เมื่อเกิดสถานการณ์ต่อไปนี้ผู้ประกอบธุรกิจอาจเปิดเผยข้อมูลส่วนบุคคลของผู้บริโภคหรือประวัติเกมตามกฎหมาย:
          </p>
          <ul>
            <li>
              1. เป็นไปตามกฎหมายและข้อบังคับและข้อกำหนดของหน่วยงานที่เกี่ยวข้อง
            </li>
            <li>2. เพื่อปกป้องทรัพย์สินและสิทธิของผู้ประกอบธุรกิจ</li>
            <li>
              3.
              เพื่อปกป้องความปลอดภัยส่วนบุคคลของผู้ประกอบธุรกิจและสมาชิกของสาธารณชนในกรณีฉุกเฉิน
            </li>
            <li>
              4.
              ประวัติเกมที่เกี่ยวข้องกับบุคคลที่สามซึ่งได้รับการตรวจสอบโดยบุคคลที่สามถึงผู้ประกอบธุรกิจ
            </li>
          </ul>
          <p></p>
        </li>
        <li>
          <p class="list-tit">ข้อ 14. บันทึกแม่เหล็กไฟฟ้า</p>
          <p class="list-des">
            บันทึกแม่เหล็กไฟฟ้าทั้งหมดของบริการเกมนี้เป็นของผู้ประกอบธุรกิจและผู้ประกอบธุรกิจจะต้องรักษาความสมบูรณ์ของบันทึกแม่เหล็กไฟฟ้าที่เกี่ยวข้องกับผู้บริโภค
          </p>
          <p class="list-des">
            ผู้บริโภคมีสิทธิ์ใช้และควบคุมบันทึกแม่เหล็กไฟฟ้าที่กล่าวถึงในย่อหน้าก่อนหน้านี้
            แต่ไม่รวมถึงพฤติกรรมการโอนและการทำกำไรที่อยู่นอกขอบเขตของบริการเกม
          </p>
          <p class="list-des">
            เพื่อปกป้องสิทธิและผลประโยชน์ของผู้บริโภคโปรดอย่าซื้อสกุลเงินเสมือนอุปกรณ์ประกอบฉากสิ่งของเสมือนจริงบัตรเครดิตรายเดือนหรือของขวัญผ่านช่องทางการซื้อรูปแบบใด
            ๆ ที่ได้รับอนุญาตจากผู้ประกอบการที่ไม่ใช่ธุรกิจ (รวมถึง แต่ไม่ จำกัด
            เพียงแพลตฟอร์มการซื้อขายและเกม ตัวแทนจำหน่ายสินค้า)
            ผู้ประกอบธุรกิจจะไม่ดำเนินการจัดการและบริการหลังการขายสำหรับปัญหาและข้อพิพาทด้านอนุพันธ์ของตน
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 15. การเปิดเผยข้อมูล</p>
          <p class="list-des">
            ผู้ประกอบธุรกิจควรให้ข้อมูลที่เกี่ยวข้องเกี่ยวกับเกมบนเว็บไซต์เกมและอัปเดตเป็นประจำ
          </p>
          <p class="list-des">
            ข้อมูลภายในของผู้ดำเนินธุรกิจเกี่ยวกับวิธีการให้คะแนนของบริการนี้การลดลงของรายการที่ไม่ต้องชำระเงินหรือการได้มาซึ่งสิ่งของเสมือนจริง
            (สกุลเงิน)
            เป็นข้อมูลภายในของผู้ดำเนินธุรกิจและผู้บริโภคไม่มีสิทธิ์ขอให้ บริษัท
            เกมจัดหาหรือเปิดเผย
          </p>
          <p class="list-des">
            ข้อมูลทั้งหมดในระหว่างบริการเกมรวมถึง แต่ไม่ จำกัด
            เพียงตัวละครอุปกรณ์ไอเทมความสามารถของปีศาจหรือข้อมูลที่คล้ายกันได้รับการออกแบบโดยผู้ดำเนินธุรกิจหากเกมต้องเล่นอย่างยุติธรรมผู้ประกอบธุรกิจสามารถปรับระบบเหล่านี้ให้เหมาะสม
            และประกาศให้ทราบทั่วกัน
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 16. คุณภาพการเชื่อมต่อ</p>
          <p class="list-des">
            หากผู้ประกอบธุรกิจวางแผนที่จะระงับบริการเกมอย่างใดอย่างหนึ่งหรือทั้งหมด
            เพื่อรักษาระบบและอุปกรณ์ของบริการเกมเขาควรประกาศในเว็บไซต์เกมหรือหน้าเกมล่วงหน้า7วัน
            แต่เป็นการชั่วคราวเร่งด่วนหรือ
            แก้ไขไม่ได้ผู้ที่รับผิดชอบต่อสาเหตุของผู้ประกอบธุรกิจไม่ จำกัด
            เพียงแค่นี้
          </p>
          <p class="list-des">
            เมื่อผู้บริโภคไม่สามารถใช้บริการเกมนี้ทางออนไลน์ได้เนื่องจากสาเหตุของผู้ประกอบธุรกิจผู้ประกอบธุรกิจควรแก้ไขหรือปรับปรุงทันที
            สำหรับค่าธรรมเนียมเกมหรือผลิตภัณฑ์ในเกมที่หักในช่วงที่ผู้บริโภคไม่สามารถใช้บริการเกมนี้ได้ผู้ประกอบธุรกิจจะคืนค่าธรรมเนียมเกมหรือผลิตภัณฑ์ที่หักโดยผู้บริโภคและให้ค่าตอบแทนอื่น
            ๆ ตามสมควรหากไม่สามารถคืนได้
          </p>
        </li>
        <li>
          <p class="list-tit">
            ข้อ 17. ความรับผิดชอบของผู้ประกอบธุรกิจและผู้บริโภค
          </p>
          <p class="list-des">
            ผู้ประกอบธุรกิจจะต้องรับผิดชอบในการให้บริการนี้ตามข้อกำหนดของสัญญานี้และดูแลรักษาระบบคอมพิวเตอร์ของตนเองให้เป็นไปตามความปลอดภัยที่สามารถคาดหวังได้อย่างสมเหตุสมผลตามมาตรฐานทางเทคโนโลยีหรือวิชาชีพในปัจจุบัน
          </p>
          <p class="list-des">
            เมื่อระบบคอมพิวเตอร์หรือบันทึกแม่เหล็กไฟฟ้าเสียหายหรือระบบคอมพิวเตอร์ทำงานผิดปกติผู้ประกอบธุรกิจจะต้องตอบสนองโดยเร็วที่สุดหลังจากดำเนินมาตรการที่เหมาะสม
          </p>
          <p class="list-des">
            หากผู้ประกอบธุรกิจละเมิดกฎระเบียบสองข้อก่อนหน้านี้หรือช่องโหว่ของโปรแกรมเกมก่อให้เกิดความเสียหายต่อข้อมูลในเกมของผู้บริโภคเขาจะต้องรับผิดต่อความเสียหายตามความเสียหายของผู้บริโภค
            แต่ผู้ประกอบธุรกิจสามารถพิสูจน์ได้ว่าเขาไม่ได้เป็นฝ่ายผิดพฤษภาคม
            ลดความรับผิดในการชดเชย
          </p>
          <p class="list-des">
            เมื่อระบบคอมพิวเตอร์ของผู้ประกอบการองค์กรมีสถานการณ์ที่กล่าวถึงในข้อที่สองผู้ประกอบการองค์กรจะไม่เรียกเก็บเงินจากผู้บริโภคจนกว่าการซ่อมแซมจะเสร็จสิ้นและทำงานได้ตามปกติ
          </p>
          <p class="list-des">
            ผู้ประกอบธุรกิจไม่สามารถช่วยจัดการข้อพิพาทระหว่างผู้บริโภคและบุคคลภายนอกที่เกิดจากการแบ่งปันบัญชีและมอบหมายให้ผู้อื่นจ่ายคะแนน
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 18. กฎการจัดการเกม</p>
          <p class="list-des">
            ในการควบคุมวิธีการเล่นเกมผู้ประกอบธุรกิจควรกำหนดกฎการจัดการเกมที่สมเหตุสมผลและเป็นธรรมและผู้บริโภคควรปฏิบัติตามกฎการจัดการเกมที่ประกาศโดยผู้ประกอบธุรกิจ
          </p>
          <p class="list-des">
            การเปลี่ยนแปลงกฎการจัดการเกมให้เป็นไปตามขั้นตอนในข้อ 21
          </p>
          <p class="list-des">
            หากกฎการจัดการเกมมีสถานการณ์อย่างใดอย่างหนึ่งต่อไปนี้ข้อกำหนดจะไม่ถูกต้อง：
          </p>
          <ul>
            <li>1. การละเมิดข้อกำหนดของสัญญานี้</li>
            <li>
              2. ลิดรอนหรือ จำกัด สิทธิตามสัญญาของผู้บริโภค อย่างไรก็ตามไม่
              จำกัด เฉพาะผู้ที่ดำเนินการโดยผู้ประกอบธุรกิจตามมาตรา 19
            </li>
          </ul>
          <p></p>
        </li>
        <li>
          <p class="list-tit">มาตรา 19: การจัดการการละเมิดกฎการจัดการเกม</p>
          <p class="list-des">
            เว้นแต่จะระบุไว้เป็นอย่างอื่นในสัญญานี้หากมีหลักฐานที่เป็นข้อเท็จจริงว่าผู้บริโภคละเมิดกฎการจัดการเกมในเกมนี้ผู้ประกอบธุรกิจจะต้องแจ้งผู้บริโภคในประกาศเว็บไซต์เกมหรือหน้าล็อกอินเกมและแจ้งให้ผู้บริโภคทราบตามการสื่อสาร
            ข้อมูลเข้าสู่ระบบ
          </p>
          <p class="list-des">
            ผู้บริโภคละเมิดกฎการจัดการเกมเป็นครั้งแรกและการปรับปรุงไม่ได้รับการปรับปรุงเมื่อได้รับแจ้งจากผู้ประกอบธุรกิจผู้ประกอบธุรกิจอาจ
            จำกัด
            สิทธิ์ของผู้บริโภคในการใช้เกมตามกฎการจัดการเกมและความรุนแรงของสถานการณ์
            หากผู้บริโภคละเมิดกฎการจัดการเกมอีกครั้งด้วยเหตุผลเดียวกันผู้ประกอบธุรกิจจะ
            จำกัด สิทธิ์ของผู้บริโภคในการเล่นเกมโดยทันทีตามกฎการจัดการเกม
          </p>
          <p class="list-des">
            สิทธิของผู้ประกอบธุรกิจในการหยุดผู้บริโภคจากการเล่นเกมตามกฎการจัดการเกมจะต้องไม่เกิน7วันต่อครั้ง
          </p>
        </li>
        <li>
          <p class="list-tit">มาตรา 20 สิทธิในการอุทธรณ์</p>
          <p class="list-des">
            ผู้บริโภคที่ไม่พอใจกับคุณภาพการเชื่อมต่อการจัดการเกมการเรียกเก็บค่าธรรมเนียมและคุณภาพการบริการอื่น
            ๆ
            ที่เกี่ยวข้องซึ่งจัดหาโดยผู้ประกอบธุรกิจหรือไม่พอใจกับการจัดการของผู้ดำเนินธุรกิจตามกฎการจัดการเกมภายในเจ็ดวันนับจากวัน
            หลังจากได้รับแจ้งหากต้องการส่งเรื่องร้องเรียนไปยังศูนย์บริการของผู้ประกอบธุรกิจหรือทางอีเมลหรือเป็นลายลักษณ์อักษรผู้ประกอบธุรกิจจะตอบกลับผลการจัดการภายใน
            15 วันหลังจากได้รับการร้องเรียน
          </p>
          <p class="list-des">
            ผู้ประกอบการธุรกิจควรระบุกล่องจดหมายร้องเรียนการบริการลูกค้าและข้อมูลติดต่ออื่น
            ๆ ที่เกี่ยวข้องอย่างชัดเจนและช่องทางการร้องเรียนตลอด 24
            ชั่วโมงบนเว็บไซต์เกมหรือกฎการจัดการเกม
          </p>
          <p class="list-des">
            ผู้บริโภคที่รายงานว่าบุคคลที่สามใช้ปลั๊กอินหรือข้อร้องเรียนอื่น ๆ
            ที่ส่งผลกระทบต่อความยุติธรรมของเกมจะต้องได้รับการจัดการตามวรรคหนึ่ง
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 21. การเปลี่ยนแปลงสัญญา</p>
          <p class="list-des">
            เมื่อผู้ประกอบธุรกิจแก้ไขสัญญานี้จะต้องประกาศในหน้าแรกของเว็บไซต์เกมและหน้าล็อกอินของเกมและแจ้งให้ผู้บริโภคทราบผ่านวิธีการสื่อสารที่ผู้บริโภคเก็บไว้
          </p>
          <p class="list-des">
            หากผู้ประกอบธุรกิจไม่ประกาศและแจ้งให้ทราบตามวรรคก่อนการเปลี่ยนแปลงสัญญาจะไม่ถูกต้อง
          </p>
          <p class="list-des">
            ผู้บริโภคภายใน 15 วันหลังจากการแจ้งเตือนครั้งแรกมาถึง：
          </p>
          <ul>
            <li>
              1.
              หากผู้บริโภคไม่ได้แสดงการคัดค้านผู้ประกอบธุรกิจจะให้บริการเกมนี้ต่อไปตามเนื้อหาของการเปลี่ยนแปลงสัญญา
            </li>
            <li>
              2.
              ผู้บริโภคที่แสดงความเห็นคัดค้านจะได้รับการจัดการในลักษณะที่ผู้บริโภคบอกเลิกสัญญานี้
            </li>
          </ul>
          <p></p>
        </li>
        <li>
          <p class="list-tit">ข้อ 22. การยกเลิกสัญญาและการคืนเงิน</p>
          <p class="list-des">
            ผู้บริโภคอาจแจ้งให้ผู้ประกอบธุรกิจทราบเป็นลายลักษณ์อักษรเพื่อบอกเลิกสัญญานี้เมื่อใดก็ได้
          </p>
          <p class="list-des">
            หากผู้บริโภคไม่ล็อคอินเพื่อใช้บริการเกมนี้ภายในหนึ่งปีผู้ประกอบธุรกิจอาจแจ้งให้ผู้บริโภคเข้าสู่ระบบภายใน
            15 วันหากผู้บริโภคยังไม่เข้าสู่ระบบเพื่อใช้เกมภายใน 15
            วันผู้ประกอบธุรกิจอาจ ยกเลิกสัญญานี้
          </p>
          <p class="list-des">
            หากผู้บริโภคมีสถานการณ์สำคัญอย่างใดอย่างหนึ่งดังต่อไปนี้ผู้ประกอบธุรกิจจะต้องยุติสัญญานี้ทันทีหลังจากแจ้งให้ผู้บริโภคทราบผ่านวิธีการสื่อสารที่ผู้บริโภคเก็บ：
          </p>
          <ul>
            <li>
              1. ใช้ระบบหรือเครื่องมือใด ๆ
              เพื่อโจมตีหรือทำลายระบบคอมพิวเตอร์ของผู้ประกอบธุรกิจโดยมีเจตนาร้าย
            </li>
            <li>
              2.
              ใช้โปรแกรมปลั๊กอินโปรแกรมไวรัสช่องโหว่ของโปรแกรมเกมหรือการละเมิดการตั้งค่าปกติของเกมหรือเล่นเกมอย่างยุติธรรมและสมเหตุสมผล
            </li>
            <li>
              3.
              การจ่ายคะแนนหรือผลิตภัณฑ์ในเกมโดยการแอบอ้างบุคคลอื่นการฉ้อโกงหรือการหลอกลวงอื่น
              ๆ
            </li>
            <li>
              4. การคืนเงินโดยไม่มีเหตุผลที่เหมาะสม:
              หมายถึงการคืนเงินหลังจากซื้อและได้รับคะแนนในเกมหรือไอเทมเสมือนจริง
            </li>
            <li>
              5.
              ผู้บริโภคเพียงแค่โอนตกลงที่จะขายหรือแลกเปลี่ยนหมายเลขบัญชีหรือบันทึกแม่เหล็กไฟฟ้า
            </li>
            <li>
              6.
              มีการละเมิดกฎการจัดการเกมมากกว่าสามครั้งเนื่องจากเหตุผลเดียวกันและการปรับปรุงไม่ได้รับการปรับปรุงหลังจากได้รับแจ้งตามมาตรา
              19 วรรค 2
            </li>
            <li>
              7. การกระทำที่ผิดกฎหมายใด ๆ ที่พบโดยกระบวนการยุติธรรม
              เมื่อผู้ประกอบธุรกิจทำผิดในข้อเท็จจริงที่ระบุไว้ในวรรคก่อนหน้านี้หรือไม่สามารถแสดงหลักฐานได้ผู้ประกอบธุรกิจจะต้องรับผิดต่อความเสียหายที่เกิดจากผู้บริโภคอันเนื่องมาจากการยกเลิกสัญญา
            </li>
          </ul>
          <p></p>
          <p class="list-des">
            เมื่อสิ้นสุดสัญญาผู้ประกอบธุรกิจจะภายใน 30
            วันหลังจากหักค่าใช้จ่ายที่จำเป็นคืนคะแนนเกมที่ไม่ได้ใช้หรือค่าธรรมเนียมให้กับผู้บริโภคเป็นเงินสดบัตรเครดิตธนาณัติหรือเช็คที่ลงทะเบียนคะแนนหรือค่าธรรมเนียมเกมหรือจัดการกับ
            คะแนนหรือค่าธรรมเนียมดังกล่าวข้างต้นในลักษณะที่ทั้งสองฝ่ายตกลงกัน
            ผู้บริโภคทราบว่าพวกเขาได้ซื้อและบริโภคไอเท็มเสมือนจริง (สกุลเงิน)
            และไม่มีสิทธิ์ขอเงินคืนจาก บริษัท เกม
          </p>
        </li>
        <li>
          <p class="list-tit">มาตรา 23 การระงับการดำเนินการ</p>
          <p class="list-des">
            หากสัญญาสิ้นสุดลงเนื่องจากผู้ประกอบธุรกิจหยุดการให้บริการเกมควรประกาศในหน้าแรกของเว็บไซต์อย่างเป็นทางการหน้าล็อกอินเกมหรือหน้าซื้อ
            30 วันก่อนการสิ้นสุดหากผู้บริโภคได้เข้าสู่ระบบการสื่อสาร
            ข้อมูลเมื่อลงทะเบียนบัญชีข้อมูลนั้นจะถูกใช้ไปข้อมูลการสื่อสารที่เก็บไว้โดยบุคคลจะแจ้งให้ผู้บริโภคทราบ
          </p>
          <p class="list-des">
            หากผู้ประกอบธุรกิจไม่ประกาศและแจ้งให้ทราบตามวรรคก่อนหน้านี้นอกจากการคืนเงินคะแนนซื้อหรือค่าธรรมเนียมเกมที่ไม่ได้ใช้ของผู้บริโภคโดยไม่หักค่าใช้จ่ายที่จำเป็นแล้วยังต้องให้ค่าตอบแทนที่สมเหตุสมผลแก่ผู้บริโภคด้วย
          </p>
        </li>
        <li>
          <p class="list-tit">ข้อ 24. บริการ</p>
          <p class="list-des">
            เกี่ยวกับการแจ้งเรื่องทั้งหมดในสัญญานี้ผู้บริโภคยินยอมให้ผู้ประกอบธุรกิจได้รับข้อมูลการสื่อสารที่เก็บรักษาไว้โดยผู้บริโภค
          </p>
          <p class="list-des">
            ผู้บริโภคควรตรวจสอบความถูกต้องของที่อยู่หรืออีเมลที่จัดเก็บไว้ในผู้ประกอบธุรกิจหากมีการเปลี่ยนแปลงใด
            ๆ
            ในสื่อการสื่อสารที่กล่าวถึงในวรรคก่อนผู้บริโภคควรแจ้งให้ผู้ประกอบธุรกิจทราบทันที
            หากการแจ้งเตือนการเปลี่ยนแปลงล่าช้าหรือไม่สามารถติดต่อหรือปฏิเสธการแจ้งเตือนได้เนื่องจากเหตุผลอื่น
            ๆ
            เมื่อมีการออกการแจ้งเตือนจากผู้ประกอบธุรกิจให้ถือว่าได้รับการดำเนินการอย่างถูกต้องตามกฎหมาย
          </p>
          <p class="list-des">
            หากผู้ประกอบธุรกิจไม่สามารถจัดส่งสินค้าได้เนื่องจากความตั้งใจหรือความประมาทของผู้บริโภคผู้ประกอบธุรกิจจะไม่รับผิดชอบต่อความเสียหายใด
            ๆ ที่เกิดจากการที่ผู้บริโภคไม่สามารถส่งมอบ
          </p>
        </li>
        <li>
          <p class="list-tit">มาตรา 25 สิทธิ์ในทรัพย์สินทางปัญญา</p>
          <p class="list-des">
            ซอฟต์แวร์เกมคู่มือและผลิตภัณฑ์อุปกรณ์ต่อพ่วงที่เกี่ยวข้องทั้งหมดนี้ได้รับการคุ้มครองตามกฎหมายลิขสิทธิ์และห้ามคัดลอกทำซ้ำหรือดัดแปลงกราฟิกและข้อความไม่ว่าในทางใดทางหนึ่งส่วนใดส่วนหนึ่งหรือทั้งหมดโดยไม่ได้รับอนุญาตจากผู้ประกอบธุรกิจ
            ผู้บริโภคไม่ได้รับอนุญาตให้ใช้เกมนี้เพื่อผลิตผลิตภัณฑ์ต่อพ่วงใด ๆ
            โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากผู้ประกอบธุรกิจ
          </p>
          <p class="list-des">
            ผู้บริโภคจะต้องไม่ใช้วิธีการใด ๆ ในการให้บริการทางธุรกิจ
            (หรือโฮสติ้ง) บริการตัวกลางหรือสกัดกั้นจำลองหรือเปลี่ยนเส้นทาง
            วิธีการที่ต้องห้ามเหล่านี้รวมถึง แต่ไม่ จำกัด
            เพียงการตั้งค่าเซิร์ฟเวอร์ส่วนตัวการทำวิศวกรรมย้อนกลับการปรับเปลี่ยนเกมหรือการเพิ่มส่วนประกอบใหม่หรือการใช้เครื่องมือบางอย่างเพื่อให้บริการการจัดการเกม
            (หรือโฮสต์)
          </p>
        </li>
        <li>
          <p class="list-tit">มาตรา 26 กฎหมายที่ใช้บังคับ</p>
          <p class="list-des">สัญญานี้อยู่ภายใต้กฎหมายของสาธารณรัฐจีน</p>
        </li>
        <li>
          <p class="list-tit">มาตรา 27 ศาลเขตอำนาจศาล</p>
          <p class="list-des">
            เนื่องจากข้อพิพาททั้งหมดที่เกี่ยวข้องกับสัญญานี้ทั้งสองฝ่ายตกลงว่าศาลแขวงซื่อหลินของไต้หวันจะเป็นศาลที่มีเขตอำนาจศาลชั้นต้น
            แต่มาตรา 47 ของกฎหมายคุ้มครองผู้บริโภคหรือมาตรา 28 วรรค 2 และ 4
            ของกฎหมายวิธีพิจารณาความแพ่งจะ ไม่ได้รับการยกเว้นมาตรา 136-9
            กำหนดให้มีการใช้ศาลที่มีเขตอำนาจศาลสำหรับการเรียกร้องเล็กน้อย
          </p>
        </li>
      </ul>
    </div>
    <div class="dash-slice"></div>
    <div class="con-tit">{{ $t('terms.privacy') }}</div>
    <div class="con-block con-about">
      <ul class="notice-list">
        <li>
          <p class="list-tit">
            เสี่ยวเมิ่ง เทคโนโลยี จำกัด (ต่อไปนี้จะเรียกว่า "เสี่ยวเมิ่ง
            เทคโนโลยี " หรือ "เรา")
            ให้ความสำคัญอย่างยิ่งต่อความเป็นส่วนตัวของคุณและนี่คือวิธีที่เรารวบรวมประมวลผลและใช้ข้อมูลส่วนบุคคลของคุณ
            เมื่อคุณลงทะเบียนเสร็จสมบูรณ์และใช้บริการสมาชิกของ บริษัท
            ถือว่าคุณได้อ่านทำความเข้าใจและตกลงที่จะยอมรับ Komoe
            นโยบายความเป็นส่วนตัวของเกม ("นโยบายนี้")
            หากคุณไม่เห็นด้วยกับนโยบายนี้ทั้งหมดหรือส่วนใดส่วนหนึ่งโปรดหยุดใช้บริการนี้ทันที
            หากคุณเป็นผู้เยาว์โปรดยืนยันว่าตัวแทนทางกฎหมายของคุณเข้าใจและยอมรับเนื้อหาของนโยบายนี้อย่างสมบูรณ์ก่อนที่จะใช้บริการนี้ต่อไป
            เมื่อคุณใช้บริการนี้เนื้อหาที่ตกลงในสัญญานี้จะถือว่าได้รับอนุญาตหรือยินยอมจากตัวแทนทางกฎหมาย
          </p>
          <p class="list-des"></p>
        </li>
        <li>
          <p class="list-tit">
            โปรดอ่านเพิ่มเติมเกี่ยวกับนโยบายการคุ้มครองความเป็นส่วนตัวด้านล่าง
          </p>
          <p class="list-des"></p>
        </li>
        <li>
          <p class="list-tit">
            ข้อมูลที่รวบรวมโดย เสี่ยวเมิ่ง เทคโนโลยี จำกัด และวิธีจัดการ
          </p>
          <p class="list-des">
            หลังจากที่คุณลงทะเบียนและ / หรือเล่นเกมมือถือของ เสี่ยวเมิ่ง
            เทคโนโลยี แล้ว เสี่ยวเมิ่ง เทคโนโลยี
            จะรวบรวมพฤติกรรมต่างๆของคุณในเกมรวมถึงแต่ไม่จำกัดเพียงข้อมูลส่วนบุคคล
            (เช่นอีเมล เพศ หมายเลขโทรศัพท์) ที่คุณให้ไว้เมื่อคุณลงทะเบียน
            บัญชีชื่อบัญชีพฤติกรรมการทำงานของเกมข้อมูลอุปกรณ์ทุกครั้งที่คุณเข้าสู่เกมหรือบริโภค
            (รวมถึงรหัสประจำตัวอุปกรณ์และรหัสประจำตัวโฆษณาภาษาของระบบรุ่นหมายเลขเวอร์ชันของระบบรูทหรือการแหกคุกความละเอียด)
            พฤติกรรมการบริโภค
            (รวมถึงเวลาและรายการที่ใช้ข้อมูลการชำระเงินเช่นหมายเลขคำสั่งซื้อที่อยู่
            IP ของเครือข่ายในขณะชำระเงิน) Google/Apple/Facebook
            ข้อมูลการอนุญาตสถานะการเข้าสู่ระบบและข้อมูลที่เกี่ยวข้องอื่น ๆ
            ที่ต้องรวบรวมเพื่อให้บริการสมาชิกของคุณและ /
            หรือบริการเล่นเกมถูกใช้เพื่อวัตถุประสงค์ในการให้บริการสมาชิกและ /
            หรือการเล่นเกมรวมถึงการให้ข้อมูลเกี่ยวกับเกมแก่คุณ
            ข้อมูลที่เกี่ยวข้องกับ Xiaomoe
            ข้อมูลการตลาดสำหรับผลิตภัณฑ์หรือบริการ ฯลฯ
            นอกจากนี้เพื่อให้คุณได้รับบริการที่ดีขึ้นการวิจัยภายในอาจดำเนินการเกี่ยวกับจำนวนความชอบและพฤติกรรมของผู้ใช้ทั้งหมดการวิจัยนี้อิงจากการวิเคราะห์พฤติกรรมโดยรวมของผู้ใช้ทั้งหมดและไม่ได้วิเคราะห์ผู้ใช้แต่ละราย
          </p>
          <p class="list-des">
            หากคุณเรียกดูเว็บไซต์ของ เสี่ยวเมิ่ง เทคโนโลยี
            หรือหน้าเว็บของพันธมิตรบางราย (ต่อไปนี้จะเรียกว่า "บุคคลที่สาม")
            และเข้าร่วมในกิจกรรมส่งเสริมการขายหรือเกมโบนัสบางอย่าง เสี่ยวเมิ่ง
            เทคโนโลยี จะรวบรวมข้อมูลส่วนบุคคลที่คุณป้อนรวมถึง แต่ไม่ จำกัด
            เพียงข้อมูล ให้บริการโดยสมาชิกที่ลงทะเบียนของคุณ
            ข้อมูลนี้อาจใช้เพื่อส่งของขวัญในงานอีเวนต์หรือเพื่อแจ้งให้คุณทราบถึงการได้รับรางวัลหรือเมื่อคุณใช้บริการสมาชิกที่เกี่ยวข้องของ
            เสี่ยวเมิ่ง เทคโนโลยี โดยทาง เสี่ยวเมิ่ง เทคโนโลยี
            จะถามรวมถึงชื่อที่อยู่วันเกิดหมายเลขประจำตัวและหมายเลขติดต่อของคุณ
            และข้อมูลอื่น ๆ เพื่ออำนวยความสะดวกให้ เสี่ยวเมิ่ง เทคโนโลยี
            ในการระบุตัวตนของคุณและให้เนื้อหาบริการที่ถูกต้องและมีประสิทธิภาพมากขึ้น
            คุณควรเข้าใจและตระหนักว่าบุคคลที่สามอาจรวบรวมข้อมูลส่วนบุคคลของคุณร่วมกันหรือเป็นอิสระกับ
            เสี่ยวเมิ่ง เทคโนโลยี
            ในกิจกรรมดังกล่าวในกรณีนี้ความสัมพันธ์ทางกฎหมายระหว่างคุณและบุคคลที่สามจะไม่ตกอยู่ในขอบเขตของนโยบายนี้คุณควรยืนยัน
            เนื้อหาของนโยบายความเป็นส่วนตัวของบุคคลที่สาม เสี่ยวเมิ่ง เทคโนโลยี
            ไม่สามารถรับประกันความสมบูรณ์และความถูกต้องตามกฎหมายของการคุ้มครองความเป็นส่วนตัวของบุคคลที่สาม
          </p>
        </li>
        <li>
          <p class="list-tit">
            ยกเว้นตามนโยบายนี้ความยินยอมอย่างชัดเจนของคุณและสถานการณ์ต่อไปนี้
            เสี่ยวเมิ่ง เทคโนโลยี
            จะไม่ให้ข้อมูลแก่บุคคลที่สามหรือใช้ข้อมูลเกินขอบเขตของวัตถุประสงค์เฉพาะและจำเป็นของนโยบายนี้：
          </p>
          <p class="list-des">
            1. เมื่อได้รับการร้องขอจากศาลยุติธรรมตำรวจหรือหน่วยงานที่มีอำนาจอื่น
            ๆ
          </p>
          <p class="list-des">
            2. เมื่อรักษาสวัสดิการสาธารณะหรือปกป้องสิทธิและผลประโยชน์ของ
            เสี่ยวเมิ่ง เทคโนโลยี หรืออื่น ๆ
          </p>
          <p class="list-des">
            3.เมื่อพฤติกรรมของสมาชิกละเมิดกฎหมายหรือข้อบังคับหรือสัญญาระหว่างคุณกับ
            เสี่ยวเมิ่ง เทคโนโลยี
          </p>
          <p class="list-des">
            4.ในกรณีฉุกเฉินเพื่อรักษาความสมบูรณ์และความปลอดภัยของสมาชิกคนอื่น ๆ
            หรือบุคคลที่สามเนื้อหาธุรกรรมประวัติเกมและข้อมูลส่วนบุคคลของสมาชิกคนอื่น
            ๆ
          </p>
          <p class="list-des">
            5.หรือพันธมิตรอื่น ๆ ของ เสี่ยวเมิ่ง
            เทคโนโลยีหากจำเป็นเพื่อให้บริการเกมแก่คุณ
            อย่างไรก็ตามพันธมิตรรายนี้จะไม่ใช้ข้อมูลที่ได้มาเพื่อวัตถุประสงค์นอกขอบเขตของสัญญา
          </p>
          <p class="list-des">6. ช่องทางกฎหมายอื่น ๆ</p>
        </li>
        <li>
          <p class="list-tit">ความปลอดภัยของข้อมูล</p>
          <p class="list-des">
            เสี่ยวเมิ่ง
            เทคโนโลยีมุ่งมั่นที่จะรับรองความปลอดภัยของข้อมูลส่วนบุคคลทั้งหมดตามเทคโนโลยีและขั้นตอนที่เหมาะสมของเทคโนโลยีปัจจุบัน
          </p>
        </li>
        <li>
          <p class="list-tit">เรื่องอื่น ๆ ที่เกี่ยวข้องต้องให้ความสนใจ</p>
          <p class="list-des">
            โปรดดูแลรหัสผ่านและหรือข้อมูลส่วนบุคคลของคุณให้ดีและอย่าให้ข้อมูลส่วนบุคคลใด
            ๆ โดยเฉพาะรหัสผ่านของคุณกับใครก็ตาม
            ก่อนที่คุณจะออกจากคอมพิวเตอร์หรือเมื่อคุณไม่ได้ใช้บริการของ
            เสี่ยวเมิ่ง เทคโนโลยี
            อีกต่อไปคุณต้องอย่าลืมออกจากระบบหากคุณใช้คอมพิวเตอร์ร่วมกับผู้อื่นหรือใช้คอมพิวเตอร์สาธารณะอย่าลืมปิดหน้าต่างเบราว์เซอร์เพื่อป้องกันไม่ให้ผู้อื่นอ่านข้อมูลส่วนบุคคลของคุณ
            ข้อมูลหรือจดหมาย
          </p>
          <p class="list-des">
            ข้อมูลส่วนบุคคลทุกประเภทที่คุณเปิดเผยทางออนไลน์โดยสมัครใจเช่นการโพสต์ข้อมูลส่วนบุคคลของคุณเช่นอีเมลและวันเกิดในพื้นที่สนทนาห้องสนทนา
            ฯลฯ อาจถูกรวบรวมและใช้โดยผู้อื่น
            หากคุณเผยแพร่ข้อมูลส่วนบุคคลทางออนไลน์ที่ผู้อื่นสามารถอ่านได้คุณอาจได้รับอีเมลที่ไม่ได้ร้องขอจากองค์กรอื่น
            ๆ โดยพื้นฐานแล้วคุณต้องรับผิดชอบ
            แต่เพียงผู้เดียวต่อการรักษาความลับของรหัสผ่านหรือข้อมูลบัญชีสมาชิกใด
            ๆ โปรดระมัดระวังและรักษาข้อมูลสมาชิกของคุณ
          </p>
          <p class="list-des">
            ข้อกำหนดที่เกี่ยวข้องกับนโยบายนี้หากไม่ได้ตกลงโดยเฉพาะให้ปฏิบัติตามสัญญาผู้ใช้
            Komoe Game ("สัญญานี้")
          </p>
        </li>
        <li>
          <p class="list-tit">การแก้ไขนโยบายการคุ้มครองความเป็นส่วนตัว</p>
          <p class="list-des">
            เสี่ยวเมิ่ง เทคโนโลยี
            ขอสงวนสิทธิ์ในการปรับเปลี่ยนและแก้ไขนโยบายนี้ตามเงื่อนไขจริงเมื่อเรามีการเปลี่ยนแปลงที่สำคัญจะมีการประกาศบนเว็บไซต์ของเราหรือแจ้งให้คุณทราบโดยวิธีการที่
            เสี่ยวเมิ่ง เทคโนโลยี เห็นว่าเหมาะสมโปรดตรวจสอบเป็นประจำหากคุณ
            ไม่สามารถยอมรับเนื้อหาที่เปลี่ยนแปลงทั้งหมดหรือบางส่วนได้โปรดหยุดใช้บริการนี้ทันทีและแจ้งให้เรายุติสัญญานี้
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.con-about {
  p {
    margin: 0;
  }
}
.about-main {
  margin-bottom: 42px;
  color: #999;
}
.notice-list {
  padding: 0;
  padding-bottom: 40px;
  margin: 0;
  ul {
    padding: 0;
    margin: 0;
  }
  li {
    list-style-type: none;
  }
  > li {
    margin-bottom: 21px;
  }
  .list-tit {
    font-weight: bold;
    color: #151515;
  }
  .list-des {
    color: #2a2a2a;
  }
}
.dash-slice {
  height: 3px;
  background: url('../../../img/dividing_dotted.png');
}
</style>
